module.exports = __webpack_public_path__ + "static/img/VDscenario3.9c0a750.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/VDscenario3.png
// module id = kwT8
// module chunks = 0